import { UserOnlineState, type User } from '@sendbird/chat';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { type MaybeNullish } from '@Types';
import { getSerializedUsersToMessage } from '../selectors';
import { type SerializedUser } from '../messaging.SerializedUser.types';

export const useGetConnectionStatus = () => {
    const usersToMessage = useSelector(getSerializedUsersToMessage);

    const getConnectionStatus = useCallback(
        (user: MaybeNullish<User | SerializedUser>) => {
            if (!user) return UserOnlineState.OFFLINE;

            if (!usersToMessage) return (user as User).connectionStatus ?? UserOnlineState.OFFLINE;
            // Check against the serialized user stored in Redux (kept up to date via usePollForUsers)
            const matchedUser = usersToMessage.availableUsers.find(
                u => (u as SerializedUser).userId === user.userId,
            ) as SerializedUser | undefined;

            if (!matchedUser) return (user as User).connectionStatus ?? UserOnlineState.OFFLINE;

            // Read connectionStatus directly from the serialized data
            return (matchedUser.connectionStatus as string) === 'online'
                ? UserOnlineState.ONLINE
                : UserOnlineState.OFFLINE;
        },
        [usersToMessage],
    );

    return getConnectionStatus;
};
